define([
	"dojo/_base/declare",
	"csi/table/New",
	"csi/xml"
], function(declare,New,xml) {

	return declare(New, {
		toWriterRequest: function(/*FormData?*/fd) {
			var call = this.inherited(arguments);
			call.addParameter("FromURL", xml.ATTR_REF, this.m_urlParent);
			return call;
		}
	});
});